import { Grid, Flex, SVG, Text, SVGs } from '@raskrask-dk/rr-components'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const CompanyOneOffExtraInfoTemplate = (): ReactElement => {
    const { t } = useTranslation()
    return (
        <Grid gap={16}>
            <Grid gap={4}>
                <Flex alignItems="center">
                    <SVG
                        src={SVGs.Exclamation}
                        css={{
                            height: '1em',
                            m: '0px 8px',
                            color: '$primary600',
                        }}
                    />
                    <Text bold>
                        {t('details.form.oneoff.extrainfo.sheetntowel.header')}
                    </Text>
                </Flex>
                <Text>
                    {t('details.form.oneoff.extrainfo.sheetntowel.text')}
                </Text>
            </Grid>
            <Grid gap={4}>
                <Flex alignItems="center">
                    <SVG
                        src={SVGs.OneOffIcon}
                        css={{
                            height: '1em',
                            m: '0px 8px',
                            color: '$primary600',
                        }}
                    />
                    <Text bold>
                        {t('details.form.oneoff.extrainfo.time.header')}
                    </Text>
                </Flex>
                <Text>{t('details.form.oneoff.extrainfo.time.text')}</Text>
            </Grid>
            <Grid gap={4}>
                <Flex alignItems="center">
                    <SVG
                        src={SVGs.LeadIcon}
                        css={{
                            height: '1em',
                            m: '0px 8px',
                            color: '$primary600',
                        }}
                    />
                    <Text bold>
                        {t('details.form.oneoff.extrainfo.cancellation.header')}
                    </Text>
                </Flex>
                <Text>
                    {t('details.form.oneoff.extrainfo.cancellation.text')}
                </Text>
            </Grid>
        </Grid>
    )
}

export default CompanyOneOffExtraInfoTemplate
